import { render, staticRenderFns } from "./DeletedAssetLog.vue?vue&type=template&id=13325742&scoped=true&"
import script from "./DeletedAssetLog.vue?vue&type=script&lang=js&"
export * from "./DeletedAssetLog.vue?vue&type=script&lang=js&"
import style0 from "./DeletedAssetLog.vue?vue&type=style&index=0&id=13325742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13325742",
  null
  
)

export default component.exports